import type { DashboardHeaderWidget } from './types';
import type { WebMapContextValue } from '../webMap/WebMapContext';

/**
 * Clean up stale header cross-filters when header widgets are removed.
 */
export function syncFilterModesFromHeaderWidgets(
  widgets: DashboardHeaderWidget[],
  ctx: WebMapContextValue | null,
): void {
  if (!ctx) return;

  const catIds = new Set(
    widgets.filter((w) => w.type === 'header_category').map((w) => `header_cat_${w.id}`),
  );
  const keys = Array.from(ctx.crossFilters.keys());
  for (const key of keys) {
    if (key.startsWith('header_cat_') && !catIds.has(key)) {
      ctx.removeCrossFilter(key);
    }
  }
}
